import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  Inject
} from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';

require('./bringoz-time-select.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-time-select',
  templateUrl: './bringoz-time-select.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozTimeSelectComponent implements OnInit, OnChanges {
  @Input() selectedTime: any;
  @Input() ticksInMinutes: any;
  @Input() min: any;
  @Input() max: any;
  @Input() placeholder: string = 'Select Time';
  @Input() isRequired: boolean = false;
  @Input() isDisabled: boolean = false;

  @Output() onSelect = new EventEmitter<number>();

  defaultTicks: number = 30;
  timeFormat: any;
  hourFormat: any;
  searchTerm: string;
  timeOptions: any[] = [];
  filteredOptions: any[] = [];

  constructor(
    @Inject('splitService') private splitService
  ) {}

  ngOnInit(): void {
    this.timeFormat = this.splitService.getDateAndTimeConfig().time;
    this.hourFormat = this.splitService.getDateAndTimeConfig().hour;
    this.setSelectedTimeOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedTime) {
      this.setSelectedTimeOptions();
    }
  }

  onOpen($event): void {
    this.setAllTimeOptions();
    this.filterOptions();
  }

  onTimeSelect(selectedTime: number): void {
    this.selectedTime = selectedTime;
    this.onSelect.emit(selectedTime);
  }

  filterOptions(): void {
    if (!this.searchTerm) {
      this.filteredOptions = this.timeOptions;
      return;
    }

    this.filteredOptions = this.timeOptions.filter(option => {
      const momentOption = moment(option);
      const hour = momentOption.format(this.hourFormat);
      const minute = momentOption.format('mm');

      const colonIndex = this.searchTerm.indexOf(':');
      const queryHour = colonIndex > -1 ? this.searchTerm.substring(0, colonIndex) : this.searchTerm;
      const queryMin = colonIndex > -1 ? this.searchTerm.substring(colonIndex + 1, this.searchTerm.length) : undefined;
      const hasOptionInTicks = (parseInt(queryMin) % (this.ticksInMinutes || this.defaultTicks)) === 0;

      const paddedQueryHour = _.toString(queryHour).padStart(2, '0');
      const paddedQueryMin = queryMin ? _.toString(queryMin).padStart(2, '0') : undefined;

      if (!paddedQueryMin) {
        return hour === paddedQueryHour;
      } else {
        if (!hasOptionInTicks) {
          return hour === paddedQueryHour;
        } else {
          return (hour === paddedQueryHour) && (minute === paddedQueryMin);
        }
      }
    });
  }

  setAllTimeOptions(): void {
    const timeOptions = [];
    const hourOptions = this.getHoursByType();
    const minOptions = this.getMinutes();
    const isValidTime = (new Date(this.selectedTime)).getTime() > 0;
    const selectedTime = isValidTime ? this.selectedTime : undefined;

    const min = this.min || moment(this.selectedTime).startOf('day').valueOf();
    const max = this.max || moment(this.selectedTime).endOf('day').valueOf();

    hourOptions.forEach(h => {
      const options = minOptions
        .map(m => {
          const time = moment(this.selectedTime || new Date())
            .set({'hour': h, 'minute': m, 'second': 0, 'millisecond': 0})
            .valueOf();
          if (moment(time).isBetween(min, max, null, '[]')) {
            return time;
          }
          return null;
        })
        .filter(time => time !== null);

      timeOptions.push(...options);
    });

    this.timeOptions = timeOptions;
    this.filteredOptions = timeOptions;
  }

  setSelectedTimeOptions(): void {
    this.timeOptions = this.selectedTime ? [this.selectedTime] : [];
    this.filteredOptions = this.timeOptions;
  }

  private getHoursByType(): number[] {
    const hours = [];
    for (let i = 0; i < 24; i++) {
      hours.push(i);
    }
    return hours;
  }

  private getMinutes(): number[] {
    const ticks = this.ticksInMinutes || this.defaultTicks;
    const times = Math.round(60 / ticks);
    const minutes = [];
    let counter;

    for (let i = 0; i < times; i++) {
      counter = _.isUndefined(counter) ? 0 : (counter + ticks);
      minutes.push(counter);
    }
    return minutes;
  }

  formatTime(time: number): string {
    return moment(time).format(this.timeFormat);
  }
}
